import ProductList_Compo from "../features/ProductList/ProductList_Compo.jsx";

function QueryPage() {
    return (
        <>
            <ProductList_Compo />
        </>
    );
}

export default QueryPage;